module.exports = __webpack_public_path__ + "img/order-empty.45f9e81f.png";